/* eslint-disable camelcase */
import {
  getApplicationPages,
  getPagesInRoles,
  patchPagesInRoles,
  getAllRoles,
} from './services/pages-roles-setting-api';

export const SET_APPLICATIONS_PAGES = 'pagesRolesSetting/SET_APPLICATIONS_PAGES';
export const SET_PAGES_IN_ROLES = 'pagesRolesSetting/SET_PAGES_IN_ROLES';
export const FETCH_APPLICATIONS_PAGES = 'pagesRolesSetting/FETCH_APPLICATIONS_PAGES';
export const FETCH_PAGES_IN_ROLES = 'pagesRolesSetting/FETCH_PAGES_IN_ROLES';
export const GET_ALL_ROLES = 'pagesRolesSetting/GET_ALL_ROLES';
export const PATCH_PAGES_IN_ROLES = 'pagesRolesSetting/PATCH_PAGES_IN_ROLES';

export const pagesRolesSettingStore = {
  state: {
    applicationPages: null,
    pagesInRoles: null,
  },
  mutations: {
    [SET_APPLICATIONS_PAGES](state, { applicationPages }) {
      state.applicationPages = applicationPages;
    },
    [SET_PAGES_IN_ROLES](state, { pagesInRoles }) {
      state.pagesInRoles = pagesInRoles;
    },
  },
  getters: {
    applicationPages: (state) => state.applicationPages,
    pagesInRoles: (state) => state.pagesInRoles,
  },
  actions: {
    [FETCH_APPLICATIONS_PAGES]: async ({ commit }) => {
      try {
        commit(SET_APPLICATIONS_PAGES, { applicationPages: null });
        await getApplicationPages()
          .then((resp) => {
            commit(SET_APPLICATIONS_PAGES, { applicationPages: resp.data });
          }).catch((error) => {
            commit(SET_APPLICATIONS_PAGES, { applicationPages: null });
            console.error(`getapplication_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_APPLICATIONS_PAGES, { applicationPages: null });
        console.error(`getapplicationpages_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_PAGES_IN_ROLES]: async ({ commit }) => {
      try {
        await getPagesInRoles()
          .then((resp) => {
            commit(SET_PAGES_IN_ROLES, { pagesInRoles: resp.data });
          }).catch((error) => {
            commit(SET_PAGES_IN_ROLES, { pagesInRoles: null });
            console.error(`getapplicationbystatus_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_PAGES_IN_ROLES, { pagesInRoles: null });
        console.error(`getapplicationbystatus_err:${error.Status}`);
        throw error;
      }
    },
    [PATCH_PAGES_IN_ROLES]: async (_, payload) => {
      try {
        const data = payload;
        await patchPagesInRoles(data);
      } catch (error) {
        console.error(`patchpageinroles_err:${error.Status}`);
        throw error;
      }
    },
    [GET_ALL_ROLES]: async () => {
      try {
        return await getAllRoles()
          .then((resp) => resp);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
